import { Component, Input } from '@angular/core';

export interface SectionHighlight {
  cards: Array<{
    icon: string;
    subtitle: string;
  }>;
}

@Component({
  selector: 'fcp-section-highlight',
  templateUrl: './section-highlight.component.html',
  styleUrls: ['./section-highlight.component.scss']
})
export class SectionHighlightComponent {

  @Input() public highlights: Array<SectionHighlight>;

}
